import { Directive, ElementRef, Renderer2, Input, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[appActiveLink]'
})
export class ActiveLinkDirective implements OnInit, OnDestroy {
  @Input() appActiveLink: string[] = [];
  private subscription!: Subscription;

  constructor(
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.subscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateActiveClass();
      });
    this.updateActiveClass();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private updateActiveClass(): void {
    const currentUrl = this.router.url;
    const isActive = this.appActiveLink.some(route => this.matchRoute(currentUrl, route));
    if (isActive) {
      this.renderer.addClass(this.el.nativeElement, 'active');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'active');
    }
  }

  private matchRoute(currentUrl: string, route: string): boolean {
    const cleanUrl = currentUrl.split('?')[0]; // ignore query params
    const regex = new RegExp(`^${route.replace(/{{.*?}}/g, '[^/]+')}$`);
    return regex.test(cleanUrl);
  }
}
